/* RVWD mega menu: model rail switching + hover-to-open on desktop */
(function () {
  function activate(model) {
    const mm = model.closest('[data-rvwd-mm]');
    if (!mm) return;
    const id = model.getAttribute('data-rvwd-target');
    mm.querySelectorAll('.rvwd-mm__model').forEach((m) => m.classList.toggle('is-active', m === model));
    mm.querySelectorAll('.rvwd-mm__panel').forEach((p) => p.classList.toggle('is-active', p.id === id));
  }

  function initRails(root) {
    root.querySelectorAll('.rvwd-mm__model').forEach((model) => {
      if (model.dataset.rvwdBound) return;
      model.dataset.rvwdBound = '1';
      let t;
      model.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => activate(model), 60); });
      model.addEventListener('mouseleave', () => clearTimeout(t));
      model.addEventListener('focus', () => activate(model));
      model.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !model.classList.contains('is-active')) {
          e.preventDefault();
          activate(model);
        }
      });
    });
  }

  function initHover(root) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches) return;
    const items = root.querySelectorAll('.rvwd-area-nav > ul > li');
    items.forEach((li) => {
      const details = li.querySelector('details');
      if (!details || li.dataset.rvwdHover) return;
      li.dataset.rvwdHover = '1';
      const summary = details.querySelector('summary');
      let openT, closeT;
      li.addEventListener('mouseenter', () => {
        clearTimeout(closeT);
        openT = setTimeout(() => {
          root.querySelectorAll('.rvwd-area-nav details[open]').forEach((d) => {
            if (d !== details) { d.removeAttribute('open'); const s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }
          });
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }, 90);
      });
      li.addEventListener('mouseleave', () => {
        clearTimeout(openT);
        closeT = setTimeout(() => {
          details.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 220);
      });
    });
  }

  function init() {
    const header = document.querySelector('.header--rvwd');
    if (!header) return;
    initRails(header);
    initHover(header);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
